import styled from '@emotion/styled'
import 'react-calendar-timeline/lib/Timeline.css'

export const MinWidthContainer = styled.div`
  width: 300px;
  overflow: hidden;
`

export const ResourceContainer = styled.div`
  overflow: auto;
  max-height: 330px;
`

export const FliterContainer = styled.div<{ visible: boolean }>`
  display: ${(props) =>
    props.visible && props.visible === true ? 'block' : 'none'};
`

export const StatusItemContainer = styled.div<{ color: string }>`
  width: 200px;
  font-size: 12px;
  padding: 5px 10px 0 5px;
  div {
    border: 1px solid ${(props) => props.color};
    border-radius: 25px;
    margin: 0 5px;
    width: 15px;
    height: 15px;
    float: left;
    background-color: ${(props) => props.color};
  }
`

export const TimelineItemHoverBox = styled.p`
  display: none;
`

export const TimeLineLeftBarGroupColors: { [id: string]: string } = {
  Building: '#5291DF',
  Office: '#B9D4F3',
  Persons: '#5291DF',
  testing: '#5291DF',
  MainCategory: '#5291DF',
  SubCategory: '#B9D4F3',
  TestTrack: '#B9D4F3',
  interimBadge: '#5291DF',
  radio: '#5291DF',
  accessCard: '#5291DF',
  remoteControl: '#5291DF',
  coldCell: '#5291DF',
  chargingInfrastructure: '#5291DF',
  fuelCard: '#5291DF',
  fuel: '#5291DF',
}
